<button type="button" class="relative appearance-none w-full cursor-pointer text-xs font-semibold px-4 py-3 rounded-xl transition-colors"
  [class.text-white]="isPrimary"
  [class.bg-primary-one]="isPrimary"
  [class.hover:bg-primary-two]="isPrimary"
  [class.hover:bg-gray-100]="isPlain"
  [class.hover:bg-red-50]="isDanger"
  [class.text-gray-500]="isPlain"
  [class.text-red-500]="isDanger"
  [class.pointer-events-none0]="loading">
  <div class="flex gap-2 justify-center items-center transition-opacity" [class.opacity-0]="loading">
    <span>{{ text }}</span>
    <img *ngIf="icon" [ngSrc]="icon" [width]="20" [height]="20" class="w-5 h-5">
  </div>

  <div class="opacity-0 transition-opacity flex items-center justify-center absolute inset-0" [class.opacity-100]="loading">
    <app-loader></app-loader>
  </div>
</button>
